import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getIssuedPolicyStart,
  getIssuedPolicySuccess,
  getIssuedPolicyFailure,
} from "../reducers/getIssuedPolicyReducer.js";
import axios from "axios";
import Cookies from "js-cookie";

export const getIssuedPolicy = createAsyncThunk(
  "getIssuedPolicy",
  async ({ id }, thunkAPI) => {
    try {
      thunkAPI.dispatch(getIssuedPolicyStart());
      const token = Cookies.get("token");
      console.log(token, "<====token");   

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Petinsurance/PetPolicyIssue?pet_Detail_Id=${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(
        getIssuedPolicySuccess(responseData?.data?.result)
      );

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(
        getIssuedPolicyFailure(error.response.data.Message)
      );

      throw error;
    }
  }
);
